import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {getImageFromRiddle} from "../../helpers/cloud-function/riddle-image";


const styles = theme => ({
	root: {
		// justifyContent: 'flex-end',
		// height: '320px',
		height: '37vh',
		minHeight: '150px',
		maxHeight: '350px',
		display: 'flex',
	},
	guessImage: {
		height: "100%",
		width: "auto",
		margin: 'auto',
		display: 'block',
		padding: "20px 0",
	},
	hintButton:{
		minWidth: 0,
		boxShadow: "none !important",
		width: '100%',
		height: '100%',
	},
	left: {
		borderRadius: "0 .4em .4em 0",
		'& button':{
			borderRadius: "0 .4em .4em 0"
		},
	},
	right: {
		borderRadius: ".4em 0 0 .4em ",
		'& button':{
			borderRadius: ".4em 0 0 .4em "
		},
	},
	active: {
		backgroundColor: "#3BBC44",
		"&:hover": {
			backgroundColor: "#238225"
		}
	},
	disabled: {
		backgroundColor: "#8E8E93"
	},
	imageContainer:{
		width: '100%',
		backgroundSize:     'cover',
		backgroundRepeat:   'no-repeat',
		backgroundPosition: 'center center',
	},
	"@media (max-width: 480px)": {
		root:{
			height: '200px',
			width: '100vw',
		},
		// guessImage:{
		// 	width: '100%',
		// 	height: 'auto',
		// },
	},
	answered: {
		// "&$root":{
		// 	height: "200px",
		// },
		"& $imageContainer":{
			width: "100%",
		},
		"& $guessImage":{
			height: '100%',
			width: 'auto',
		}
	},
	shake: {
		animation: "$shake 0.82s cubic-bezier(.36,.07,.19,.97) both",
		transform: "translate3d(0, 0, 0)",
		backfaceVisibility: "hidden",
		perspective: "1000px"
	},
	"@keyframes shake": {
		"10%, 90%": {
			transform: "translate3d(-1px, 0, 0),"
		},

		"20%, 80%": {
			transform: "translate3d(2px, 0, 0)"
		},

		"30%, 50%, 70% ": {
			transform: "translate3d(-4px, 0, 0)"
		},

		"40%, 60% ": {
			transform: "translate3d(4px, 0, 0)"
		}
	}
});

function LogoArea(props){
	const { classes, activeLogo, isShaking } = props;

	const image = getImageFromRiddle(activeLogo);

	const isAnswered = !!activeLogo.answer;
	return (
		<div className={ isAnswered ? [classes.root, classes.answered].join(" ") : classes.root }>
			<div className={classes.imageContainer}
			     // style={{backgroundImage : `url(${getImage(activeLogo.imgSolved || activeLogo.img)})`}}
			>
				<img
					src={image}
					className={`${classes.guessImage} ${isShaking ? classes.shake : ""}`}
					alt="guess-this-logo"
				/>
			</div>
		</div>
	);
}

LogoArea.propTypes = {
	isShaking: PropTypes.bool,

	activeLogo: PropTypes.object.isRequired,

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
		guessImage: PropTypes.string.isRequired,
		left: PropTypes.string.isRequired,
		right: PropTypes.string.isRequired,
		active: PropTypes.string.isRequired,
		disabled: PropTypes.string.isRequired,
		imageContainer: PropTypes.string.isRequired,
	}).isRequired,
};

export default withStyles(styles)(LogoArea);
